module.exports = __webpack_public_path__ + "static/media/Hytte.e368b66e.PNG";